var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",attrs:{"color":_vm.color,"size":_vm.size,"disabled":_vm.disabled,"active":_vm.active}})
}
var staticRenderFns = []

export { render, staticRenderFns }